import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FontIcon } from '@fluentui/react/lib/Icon';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = (_, { palette = {} }) => ({
  container: {
    width: 205,
    height: 160,
    position: 'relative',
    border: `1px dashed ${palette.themePrimary}`,
    borderRadius: '4px',
    color: palette.themePrimary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: palette.white,
    '&:hover': {
      border: `1px solid ${palette.themePrimary}`,
      outline: `1px solid ${palette.themePrimary}`,
    },
  },
  icon: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    borderRadius: '99px',
    width: 44,
    height: 44,
    background: 'white',
    marginBottom: '5px',
  },
});

const UnStyledAddImagesPlaceholder = ({
  i18n,
  onClick,
  classes,
  className,
  text,
}) => (
  <button
    className={classNames(classes.container, 'smart-page-add-images-placeholder-btn', className)}
    onClick={onClick}
  >
    <FontIcon aria-label="Add" iconName="Add" className={classes.icon} />
    <span>{text || i18n.getString(_TL_('Add photos'))}</span>
  </button>
);

UnStyledAddImagesPlaceholder.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
};

UnStyledAddImagesPlaceholder.defaultProps = {
  className: null,
  text: '',
};

export const AddImagesPlaceholder = withDefaultStyles(
  UnStyledAddImagesPlaceholder,
  getStyles
);
